import { ArrowSyncIcon, AlertWarningTriangleIcon, BlockIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorSurfaceSuccess, colorTextAction, colorTextDestructive, colorTextSecondary, colorTextWarning } from '@calendly/ui/theme';
import React from 'react';
import { DISPLAY_STATUS, DisplayStatus } from 'components/meetings/utils';
const statusContainerCss = "siqt6nm";
const statusTextCss = "s14sv6i6";
const pulsingDotContainerCss = "pmixsw1";
const pulsingDotInnerCss = "p1d8gpc0";
const PulsingDot: React.FC = () => <div className={pulsingDotContainerCss}>
    <div className={pulsingDotInnerCss} />
  </div>;
export interface MeetingStatusIndicatorProps {
  status: DisplayStatus;
  displayText: string;
}
interface StatusConfig {
  color: string;
  icon?: React.ComponentType<any>;
}
const STATUS_CONFIGS: Record<DisplayStatus, StatusConfig> = {
  CANCELLED: {
    color: colorTextDestructive,
    icon: BlockIcon
  },
  IN_PROGRESS: {
    color: colorSurfaceSuccess
  },
  STARTING_SOON: {
    color: colorTextAction
  },
  UPCOMING: {
    color: colorTextAction
  },
  UP_NEXT: {
    color: colorTextAction
  },
  NO_SHOW: {
    color: colorTextWarning,
    icon: AlertWarningTriangleIcon
  },
  RESCHEDULED: {
    color: colorTextSecondary,
    icon: ArrowSyncIcon
  }
};

/**
 * Renders a status badge for meeting time-based statuses such as
 * in-progress, starting soon, upcoming, up next, and no show.
 * Used alongside MeetingWarningIndicator.
 */
export const MeetingStatusIndicator: React.FC<MeetingStatusIndicatorProps> = ({
  status,
  displayText
}) => {
  const config = STATUS_CONFIGS[status];
  if (!config) {
    return null;
  }
  const Icon = config.icon;
  const isInProgress = status === DISPLAY_STATUS.IN_PROGRESS;
  return <div className={statusContainerCss}>
      {isInProgress ? <PulsingDot /> : Icon && <Icon color={config.color} />}
      <BodyText size="small" weight="semibold" color={config.color} inline>
        <div className={statusTextCss}>
          {displayText}
        </div>
      </BodyText>
    </div>;
};

require("./MeetingStatusIndicator.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingStatusIndicator.tsx");